module.exports = {
    "Empty": `\u{386}\u{3B4}\u{3B5}\u{3B9}\u{3BF}`
};


//# sourceMappingURL=el-GR.main.js.map
